/*
 * Laurent: "Mehr laden" auf der Kollektionsseite (Spec 12.7).
 *
 * Craft kennt nur Seitenzahlen. Der Knopf im Template ist deshalb zuerst ein
 * gewoehnlicher Link auf die naechste Seite — ohne JavaScript blaettert er
 * normal weiter. Diese Datei faengt den Klick ab, holt dieselbe Seite und
 * haengt ihre Karten ans bestehende Raster an.
 *
 * Kein unendliches Scrollen: geladen wird nur auf Klick.
 *
 * Welches Raster nachgefuellt wird, steht am Knopf (data-lh-mehr-raster);
 * ohne Angabe ist es Crafts #product-grid.
 *
 * Der Knopf liegt auf der Kollektionsseite in #ProductGridContainer. Filter und Sortierung ersetzen
 * diesen Container komplett (facets.js), damit stimmt der Knopf danach von
 * selbst wieder — er kommt frisch vom Server. Deshalb haengt der Zuhoerer am
 * Dokument und nicht am Knopf.
 */

document.addEventListener('click', async (event) => {
  const knopf = event.target.closest('[data-lh-mehr]');
  if (!knopf) return;

  event.preventDefault();
  if (knopf.getAttribute('aria-busy') === 'true') return;

  const ziel = knopf.href;
  if (!ziel) return;

  knopf.setAttribute('aria-busy', 'true');

  try {
    const antwort = await fetch(ziel);
    if (!antwort.ok) throw new Error(antwort.status);

    const seite = new DOMParser().parseFromString(await antwort.text(), 'text/html');

    /* Welche Raster nachgefuellt werden, sagt der Knopf. Ohne Angabe bleibt es
       Crafts #product-grid — die Kollektionsseite braucht davon nichts zu
       wissen. Die Blog-Indexseite (Spec 28.5) reicht #lh-blograster durch,
       die Suche (Spec 37) gleich drei durch Komma getrennte: dort stehen
       Produkte, Beitraege und Seiten in eigenen Abschnitten, und die
       naechste Seite kann zu jedem davon etwas beitragen. */
    const wahlen = (knopf.dataset.lhMehrRaster || '#product-grid')
      .split(',')
      .map((w) => w.trim())
      .filter(Boolean);

    const huelle = knopf.closest('.lh-mehr');
    let etwasGefunden = false;

    for (const wahl of wahlen) {
      const nachschub = seite.querySelector(wahl);
      if (!nachschub) continue;

      const raster = document.querySelector(wahl);

      /* Den Abschnitt gab es auf dieser Seite noch nicht — dann kommt er als
         Ganzes dazu, vor dem Knopf, damit die Reihenfolge stimmt. */
      if (!raster) {
        const abschnitt = nachschub.closest('section') || nachschub;
        abschnitt.querySelectorAll('.scroll-trigger').forEach((e) => e.classList.add('scroll-trigger--cancel'));
        huelle.parentNode.insertBefore(abschnitt, huelle);
        etwasGefunden = true;
        continue;
      }

      etwasGefunden = true;
      const neue = Array.from(nachschub.children);

      /* Die Karten tragen Crafts Einblend-Animation und starten auf
         opacity: 0. Der IntersectionObserver laeuft nur ueber das, was beim
         Laden schon dastand — nachgereichte Karten blieben sonst unsichtbar.
         Craft loest das in facets.js genauso, ueber scroll-trigger--cancel. */
      const entsperren = (el) => {
        el.querySelectorAll('.scroll-trigger').forEach((e) => e.classList.add('scroll-trigger--cancel'));
        if (el.classList.contains('scroll-trigger')) el.classList.add('scroll-trigger--cancel');
      };

      /* Endet die geladene Seite mit einem Rasterstueck und beginnt die
         naechste ebenfalls mit einem, gehoeren deren Karten in dasselbe
         Raster. Sonst stuenden zwei Raster untereinander und die Reihe risse
         am Seitenwechsel auf: erst eine Reihe mit zwei Karten, dann eine neue
         mit vier. Der Neunerzyklus selbst rechnet serverseitig weiter, hier
         wird nur zusammengefuegt, was optisch eine Reihe ist. */
      const letztes = raster.lastElementChild;
      if (
        letztes &&
        letztes.classList.contains('lh-raster') &&
        neue[0] &&
        neue[0].classList.contains('lh-raster')
      ) {
        const erstesNeu = neue.shift();
        Array.from(erstesNeu.children).forEach((karte) => {
          entsperren(karte);
          letztes.append(karte);
        });
      }

      neue.forEach(entsperren);
      raster.append(...neue);
    }

    if (!etwasGefunden) throw new Error('Raster nicht gefunden');

    /* Der Knopf der nachgeladenen Seite zeigt auf die uebernaechste. Gibt es
       ihn dort nicht mehr, war das die letzte Seite. */
    const naechster = seite.querySelector('[data-lh-mehr]');
    if (naechster) {
      knopf.href = naechster.href;
      knopf.removeAttribute('aria-busy');
    } else {
      knopf.closest('.lh-mehr').remove();
    }
  } catch (fehler) {
    /* Fehlgeschlagen: der Knopf bleibt ein Link. Der naechste Klick blaettert
       dann auf die naechste Seite, statt still nichts zu tun. */
    console.error('Mehr laden fehlgeschlagen:', fehler);
    knopf.removeAttribute('aria-busy');
    window.location.href = ziel;
  }
});
